// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"202":"9ef42855","364":"5b37e285","415":"f8c166bd","487":"1bd0e57a"}[chunkId] + ".chunk.css";
};